// Update API configuration to use the correct backend URL
const API = {
  BASE_URL: 'http://localhost:5001',
  EVENTS: 'http://localhost:5001/api/events',
  AUTH: 'http://localhost:5001/api/auth',
  CHECKIN: 'http://localhost:5001/api/checkin',
  PROFILE: 'http://localhost:5001/api/profile',
  UPLOADS: 'http://localhost:5001/uploads'
};

export default API;
